import React, { useState, useEffect } from 'react';
import { blockHeight } from 'utils/Helper';
import PropTypes from 'prop-types';
import HtmlColumn from './HtmlColumn';
import QlikColumn from './QlikColumn';
import { Typography } from '@material-ui/core';
import Box from 'components/UI/Box';
import * as Icon from 'react-feather';
import Section from 'components/UI/Section';
import ColumnDescription from './ColumnDescription';
import { defaultStyles } from 'utils/Theme';
import clsx from 'clsx';
import FormLayout from '../../../../common/FormLayout';

const Column = ({ object, qsOptions }) => {
    const [showingDescription, setShowingDescription] = useState(false);
    const [height, setHeight] = useState(null);
    const classes = defaultStyles();

    useEffect(() => {
        setHeight(blockHeight(object));
    }, []);

    return (
        <Section elevation={object.elevation || 1}>
            <Box
                component={'div'}
                className={clsx(' u-p-xsmall')}
                style={{ position: 'relative' }}
            >
                {object.title && (
                    <Typography variant={'h6'} className={'truncate'} style={{marginBottom:'10px'}}>
                        {object.title}
                    </Typography>
                )}

                {object.description && (
                    <Box
                        component="div"
                        className={'u-position-tr'}
                        style={{ zIndex: 5 }}
                    >
                        <Box
                            component="span"
                            className={classes.colorPrimary}
                            onClick={() =>
                                setShowingDescription((prevShow) => !prevShow)
                            }
                            style={{ cursor: 'pointer' }}
                        >
                            {!showingDescription ? (
                                <Icon.Info />
                            ) : (
                                <Icon.BarChart2 />
                            )}
                        </Box>
                    </Box>
                )}

                {showingDescription && (
                    <ColumnDescription object={object} height={height} />
                )}

                {!showingDescription &&
                    object.type !== 'draftObject' &&
                    object.type !== 'formObject' && (
                        <QlikColumn
                            qsOptions={qsOptions}
                            object={object}
                            height={height}
                        />
                    )}
                {!showingDescription && object.type === 'draftObject' && (
                    <HtmlColumn object={object} height={height} />
                )}
                {!showingDescription && object.type === 'formObject' && (
                    <FormLayout object={object} removeSubmit={false} />
                )}
            </Box>
        </Section>
    );
};

Column.propTypes = {
    object: PropTypes.object.isRequired,
    qsOptions: PropTypes.object,
    handleDescriptionClick: PropTypes.func,
    classes: PropTypes.object,
    row: PropTypes.object,
};

export default Column;
